import { CASH_FLOW_CATEGORIES, type CashFlowCategory } from '@progear/finance-core';

/**
 * The ONE place the 7 cash-flow lines map to their Estonian UI label + direction
 * (master rule: don't reinvent terminology per component). The treasury matrix,
 * the ledger and the composition modal all read this, so a line is named/ordered
 * identically everywhere.
 */
export const LINE_META: Record<CashFlowCategory, { label: string; kind: 'income' | 'cost' }> = {
  sale: { label: 'Müük', kind: 'income' },
  direct_cost: { label: 'Otsekulud', kind: 'cost' },
  operating_cost: { label: 'Tegevuskulud', kind: 'cost' },
  payroll: { label: 'Tööjõukulud', kind: 'cost' },
  financial_cost: { label: 'Finantskulud', kind: 'cost' },
  tax_agreement: { label: 'Maksud', kind: 'cost' },
  loan: { label: 'Laenud', kind: 'cost' },
};

export const INCOME_CATS = CASH_FLOW_CATEGORIES.filter((c) => LINE_META[c].kind === 'income');
export const COST_CATS = CASH_FLOW_CATEGORIES.filter((c) => LINE_META[c].kind === 'cost');
